export default function PrintSection({ visible = true, data, children }) {
    const hasData = data === undefined
        ? true
        : Array.isArray(data)
            ? data.length > 0
            : !!data;

    if (!hasData) return null;

    return (
        <div className={!visible ? "print:hidden" : ""}>
            {children}
        </div>
    )
}